import React from 'react';
import { useI18n, type Language } from '../i18n';
import { authService } from '../services/authService';
import { languagePreferenceService } from '../services/languagePreferenceService';
import './LanguageSwitcher.css';

const languageLabels: Record<Language, string> = {
  en: 'EN',
  fr: 'FR',
};

export default function LanguageSwitcher() {
  const { language, setLanguage, t } = useI18n();

  const chooseLanguage = (nextLanguage: Language) => {
    setLanguage(nextLanguage);
    void authService.getCurrentUser().then(({ data }) => {
      if (data.user) {
        return languagePreferenceService.savePreference(data.user.id, nextLanguage);
      }
      return undefined;
    });
  };

  return (
    <div
      className="language-switcher"
      role="group"
      aria-label={t('Language')}
      title={t('Language')}
    >
      {(Object.keys(languageLabels) as Language[]).map((option) => (
        <button
          key={option}
          type="button"
          className={`language-switcher__option ${language === option ? 'language-switcher__option--active' : ''}`}
          onClick={() => chooseLanguage(option)}
          aria-pressed={language === option}
          aria-label={option === 'en' ? 'English' : 'Français'}
        >
          {languageLabels[option]}
        </button>
      ))}
    </div>
  );
}
